var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSamlebox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20mm",
    height: "7.2336mm",
    viewBox: "0 0 20 7.2336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12143 0h15399v28062h-15399v-28062"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.5151 -107.78)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 .0010696 .0010696 0 1.9544 89.857)",
    clipPath: "url(#clipPath23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23402 22845h-6527l6527-18463zm-6527 0 6527-18463h-6527z",
    fill: "#969696",
    stroke: "#969696",
    strokeMiterlimit: 10,
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16875 4382v18463h6527v-18463h-6527",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 236
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamlebox);
export default __webpack_public_path__ + "static/media/samlebox.e9b2494acf4d04e4985d49eb688acc49.svg";
export { ForwardRef as ReactComponent };